import { lazy } from "react";
import ErrorBoundary from "@/hoc/ErrorBoundary/ErrorBoundary.jsx";

const HelpAndSupport = lazy(() => import("./HelpAndSupport"));

export const helpAndSupportRoute = {
  path: "help-and-support",
  element: <HelpAndSupport />,
  errorElement: <ErrorBoundary />
};
